module.exports = {"zh-CN":{"sysName":"跨境贸易大数据平台"},"en":{"sysName":"跨境贸易大数据平台"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/common/headerNoLogin/header-no-login-lan.json
// module id = nH8B
// module chunks = 1